import { render, staticRenderFns } from "./NewCommentForm.vue?vue&type=template&id=375db6f7&scoped=true"
import script from "./NewCommentForm.vue?vue&type=script&lang=js"
export * from "./NewCommentForm.vue?vue&type=script&lang=js"
import style0 from "./NewCommentForm.vue?vue&type=style&index=0&id=375db6f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375db6f7",
  null
  
)

export default component.exports